import isMobile from 'ismobilejs'
import qs from 'query-string'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { bindActionCreators } from 'redux'

import { getAccessToken } from '@driftt/web-auth'

import config from 'config'
import * as MetricsActions from 'modules/metrics/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as UserActions from 'modules/user/actions'
import { isExtensionInstalled } from 'utils/extension'
import { countAppMetric } from 'utils/metrics'
import { hasCompletedVideoOnboarding } from 'utils/trackingUtils'

import VideoController from './component'

const mapStateToProps = (state) => ({
  orgId: OrgSelectors.getOrgId(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchUser: UserActions.fetchUser,
      sendDriftAppMetric: MetricsActions.sendDriftAppMetric,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('loginUrl', 'setLoginUrl', `${config.START_WEB_URL}/login`),
  lifecycle({
    async componentDidMount() {
      // If they haven't authed before & haven't finished onboarding, this is likely their first
      // time here & we should log it for the onboarding completion dashboard
      if (!getAccessToken() && !hasCompletedVideoOnboarding) {
        this.props.actions.sendDriftAppMetric(
          countAppMetric('enteredOnboarding')
        )
      }

      // Fetch user if you have an account but the store isn't hydrated yet
      if (!this.props.orgId && getAccessToken()) {
        this.props.actions.fetchUser()
      }

      let redirect
      const hasExtension = await isExtensionInstalled()

      if (isMobile.any) {
        redirect = `${config.LETS_GO_URL}/letsgo/video/success`
      } else if (hasExtension) {
        redirect = `${config.LETS_GO_URL}/letsgo/video/landing`
      } else {
        redirect = `${config.LETS_GO_URL}/letsgo/video/extension`
      }
      this.props.setLoginUrl(
        `${config.START_WEB_URL}/login?${qs.stringify({ redirect })}`
      )
    },
  })
)(VideoController)
